<template>
  <div class="fivePropertyServe">
    <!-- <div class="index-header">
      <span class="title" @click="enterEaArea(eaAreaCode)"> 
        <i class="el-icon-caret-right"></i>{{cellData.eaAreaName}} 
      </span>
      <span class="other more" @click="enterEaArea(eaAreaCode)">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </div>-->
    <div class="safeProduction-main">
      <div class="left font">
        <span style="display: flex">
          <span>小区名称：</span>
          <p>
            <span
              class="fontw600 colorChange"
              @click="enterEaArea(cellData.eaAreaCode)"
              >{{ cellData.eaAreaName }}</span
            >
          </p>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            
            <el-dropdown-menu slot="dropdown">
              <template v-for="(item, index) in AreaList">
                <el-dropdown-item :key="index" :command="item.EaAreaCode">{{
                  item.EaAreaName
                }}</el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </el-dropdown>
          <span
            v-if="!cellData.eaAreaName"
            style="color: #1890ff"
            class="fontw600"
            >—</span
          >
          <i class="danger-icon" @click.prevent="showDanderInfo" v-if="cellData.hiddendangerVo">
            <img src="./img/danger.png" />
          </i>
        </span>
        <span v-if="cellData.cantonName" class="marTop15">
          行政区域：
          <span style="color: #1890ff" class="fontw600">{{
            cellData.cantonName
          }}</span>
        </span>
        <span v-if="!cellData.cantonName" class="marTop15">
          行政区域：
          <span style="color: #1890ff" class="fontw600">—</span>
        </span>
        <div class="marTop15">
          <span class>小区物业面积：</span>
          <span
            class="fontNum fontw600"
            style="color: #1890ff"
            v-if="cellData.dimensionsSum != null"
            >{{ cellData.dimensionsSum }}</span
          >
          <span
            class="fontNum fontw600"
            style="color: #1890ff"
            v-if="cellData.dimensionsSum == null"
            >—</span
          >
          <span v-if="cellData.dimensionsSum != null">m²</span>
        </div>
        <div class="marTop15">
          <span class>上次安全检查得分：</span>
          <span
            class="fontNum fontw600"
            style="color: #1890ff"
            v-if="cellData.checkScore != null"
            >{{ cellData.checkScore }}</span
          >
          <span
            class="fontNum fontw600"
            style="color: #1890ff"
            v-if="cellData.checkScore == null"
            >—</span
          >
          <span v-if="cellData.checkScore != null">分</span>
        </div>
        <div class="marTop15">
          <span class>维修资金余额：</span>
          <span class="fontNum fontw600" style="color: #1890ff">—</span>
          <!--  <span>元</span> -->
        </div>
        <div class="marTop15">
          <span class>业委会主任：</span>
          <span
            v-if="cellData.ownerTeam === 'null null' || !cellData.ownerTeam"
            class="fontNum fontw600"
            style="color: #1890ff"
            >—</span
          >
          <span v-else>{{ cellData.ownerTeam }}</span>
        </div>
      </div>

      <div class="right" style="border-left: 1px dotted #797979">
        <span
          class="colorChange"
          style="font-size: 17px; align-self: center; cursor: pointer"
          @click="lookOwnerEvaluationDetailList(cellData.eaAreaCode)"
          >上月业主评价情况</span
        >
        <div class="marTop5" style="padding-left: 10px">
          <span>得分：</span>
          <span v-if="cellData.average != null" style="color: red">{{
            cellData.average
          }}</span>
          <!-- cursor:pointer; -->
          <!-- @click="PropertyServeScore()" -->
          <span v-if="cellData.average == null" style="color: red">—</span>
          <span v-if="cellData.average != null">分</span>
          <span>（</span>
          <span>评价人数：</span>
          <span v-if="cellData.evaCard != null" style="color: #1890ff">{{
            cellData.evaCard
          }}</span>
          <span v-if="cellData.evaCard == null">—</span>
          <span v-if="cellData.evaCard != null">人</span>
          <span>）</span>
        </div>
        <div class="marTop5" style="padding-left: 10px">
          <span class>排名：</span>
          <span v-if="cellData.rank != null" style="color: red">{{
            cellData.rank
          }}</span>
          <span v-if="cellData.rank == null" style="color: red">—</span>
          <span v-if="cellData.rank != null">名</span>
          <span>（</span>
          <span>评价机构：</span>
          <span style="color: #1890ff" v-if="cellData.orgCount != null">{{
            cellData.orgCount
          }}</span>
          <span style="color: #1890ff" v-if="cellData.orgCount == null">—</span>
          <span v-if="cellData.orgCount != null">个</span>
          <span>）</span>
        </div>
        <!-- <div v-if="!cellData.rank" class="marTop5" style="align-self: center;">
            <span class="">排名：</span>
        <span style="color:red;">暂—</span>
        <span>（</span>
        <span>评价机构：</span>
        <span v-if="cellData.orgCount" style="color:#1890ff">{{cellData.orgCount}}</span>
        <span v-if="!cellData.orgCount">暂—</span>
        <span v-if="cellData.orgCount">个</span>
        <span>）</span>
        </div>-->
        <!-- <span class="font1">近六个月得分情况：</span> -->
        <!-- <div class="flexRow marTop15">
        <span class="font1">上月全市参与总评小区数：</span>
        <span>（</span>
        <span style="color:red;">100</span>
        <span>）</span>
        </div>-->
        <div ref="main" class style="min-width: 320px; height: 170px"></div>
      </div>
    </div>
    <el-dialog
      title="安全隐患"
      :visible.sync="managerDangerDialog"
      width="30%"
      :close-on-click-modal="false"
      custom-class="manager-danger-dialog"
    >
      <div class="danger-info">
        <div class="area-name">
          项目{{ cellData.hiddendangerVo?.EaAreaName }}有如下安全隐患问题：
        </div>
        <div
          class="item-info"
          v-for="(item, index) in cellData.hiddendangerVo?.TypeVos"
          :key="item.SafeHdType"
        >
          {{ index + 1 }}、{{ item.SafeHdName }}
        </div>
        <div class="info-time">
          登记时间：
          {{
            cellData.hiddendangerVo?.CreateTime | formatDate('yyyy年MM月dd日')
          }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonTitle from '@/assets/js/commonTitle.js';
import { EaAreaControllerSvr } from '@/service/EaAreaControllerSvr';
import { HomeControllerSvr } from '@/service/HomeControllerSvr';
import { HomePageControllerSvr } from '@/service/HomePageControllerSvr/HomePageControllerSvr';
import { CantonMgeSvr } from '@/service/CantonMgeSvr.js'; //获取行政区域列表
import { mapState } from 'vuex';
import { identityEnum } from '@/enum/identityEnum';
export default {
  components: {},
  props: {},
  data() {
    return {
      eaAreaCode: '',
      cantonName: '',
      month: [],
      data: {},
      cellData: {},
      Position: 'running',
      evaluateObjType: '',
      evaluateEnum: {
        项目经理: 1,
        业委会: 2,
      },
      AreaList: [],
      managerDangerDialog: false,
    };
  },
  computed: {
    ...mapState(['token', 'userInfo']),
    mainTitle: () => {
      return commonTitle;
    },
  },
  created() {
    this.EaAreaControllerSvr = new EaAreaControllerSvr();
    this.homePageControllerSvr = new HomePageControllerSvr();
    this.HomeControllerSvr = new HomeControllerSvr();
    this.cantonMgeSvr = new CantonMgeSvr();
    this.evaluateObjType = new identityEnum()[
      this.userInfo.UserParam.UserSigns.split(',')[0]
    ];
  },
  mounted() {
    /*  this.HomeControllerSvr.GetEvaluteProfile(this.token).then(res=>{
      
    }); */
    /* this.homePageControllerSvr.GetAreaInfo(this.token, 0, 1).then(res => {
      this.eaAreaCode = res._Items[0].EaAreaCode;
    }); */
    this.getAreaList();
    this.getMonth();

    /* if(!this.cellData.nearScore){
    this.getEcharNoData(this.$refs.main);
     } */
  },
  methods: {
    handleCommand(command) {
      this.getparData(command);
    },
    // 显示安全隐患信息
    showDanderInfo() {
      this.managerDangerDialog = true;
    },
    //跳转评价列表
    lookOwnerEvaluationDetailList(code) {
      // this.$router.push({
      //   path: "/ownerEvaluationDetailList",
      //   query: {
      //     args: false //true表更多  false单个业主
      //   }
      // });
      this.$router.push({
        path: '/OwnerEvaluationStatistics',
        query: {
          EaAreaCode: code,
          EaAreaName: this.cellData.eaAreaName,
          args: false, //true表更多  false单个业主
        },
      });
    },
    //获取小区列表
    getAreaList() {
      this.EaAreaControllerSvr.GetEaAreaForManagerOrOwnerTeam(this.token).then(
        (res) => {
          this.AreaList = res._Items;
          this.getparData(this.AreaList[0].EaAreaCode);
        }
      );
    },
    PropertyServeScore() {
      this.$router.push({
        path: '/PropertyServeScore',
      });
    },
    enterEaArea(code) {
      if (code) {
        this.$router.push({
          path: '/propertyAreaInfo',
          query: {
            EaAreaCode: code,
            OrgCode: code,
            t: Date.now(),
          },
        });
      }
    },
    getparData(EaAreaCode) {
      this.HomeControllerSvr.GetEaAreaInfo(
        this.token,
        this.evaluateEnum[this.evaluateObjType],
        EaAreaCode
      )
        .then((res) => {
          this.cellData = res;
          this.getEchar(this.$refs.main);
        })
        .catch(() => {
          this.getEcharNoData(this.$refs.main);
        });
    },

    //根据行政区域code获取行政区域
    getCanton() {
      this.cantonMgeSvr
        .GetCanton(this.token, this.cellData.CantonCode, true)
        .then((res) => {
          this.cantonName = res.CantonName;
        });
    },
    getEcharNoData(dom) {
      let echarDom = this.$echarts.init(dom);
      let option = {
        title: {
          text: '最近六个月得分走势图',
          left: 'center',
          textStyle: { fontSize: 13 },
          top: 10,
        },
        tooltip: {
          trigger: 'axis',
        },

        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          axisTick: {
            //x轴刻度线
            show: false,
          },
          /* axisLine:{ //x轴
    	    show:false
        }, */
          boundaryGap: false,
          data: [
            this.month[5],
            this.month[4],
            this.month[3],
            this.month[2],
            this.month[1],
            this.month[0],
          ],
        },
        yAxis: {
          align: 'left',
          /* splitLine:{show: false}, */
          axisTick: {
            //y轴刻度线
            show: false,
          },
          /* axisLine:{ //y轴
    	    show:false
        }, */
          type: 'value',
          name: '得分',
          nameLocation: 'end',
          nameGap: 10,
          nameTextStyle: { color: '#1890ff' },
          min: 0,
          max: 100,
        },
        series: [
          {
            name: '得分',
            type: 'line',

            label: {
              normal: {
                show: false,
              },
            },
            data: [],
          },
        ],
      };
      echarDom.setOption(option);
    },
    getEchar(dom) {
      let echarDom = this.$echarts.init(dom);
      let option = {
        title: {
          text: '最近六个月得分走势图',
          left: 'center',
          textStyle: { fontSize: 13 },
          top: 10,
        },
        tooltip: {
          trigger: 'axis',
        },

        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          axisTick: {
            //x轴刻度线
            show: false,
          },
          /* axisLine:{ //x轴
    	    show:false
        }, */
          boundaryGap: false,
          data: [
            this.month[0],
            this.month[1],
            this.month[2],
            this.month[3],
            this.month[4],
            this.month[5],
          ],
        },
        yAxis: {
          align: 'left',
          /* splitLine:{show: false}, */
          axisTick: {
            //y轴刻度线
            show: false,
          },
          /* axisLine:{ //y轴
    	    show:false
        }, */
          type: 'value',
          //name: '得分',
          nameLocation: 'end',
          nameGap: 10,
          nameTextStyle: { color: '#1890ff' },
          min: 0,
          max: 100,
        },
        series: [
          {
            color: '#1890ff',
            name: '得分',
            type: 'line',

            label: {
              normal: {
                show: false,
              },
            },
            data: this.cellData.nearScore,
          },
        ],
      };
      echarDom.setOption(option);
    },
    getMonth: function () {
      //创建现在的时间
      let data = new Date();
      //获取年
      let year = data.getFullYear();
      let years = data.getFullYear();
      //获取月
      let mon = data.getMonth() + 1;
      let mons = data.getMonth() + 1;
      let arry = [];
      let list = [];
      let mon1 = mon,
        mon2 = mons,
        year1 = year,
        year2 = years;
      //获取前6个月的数组
      for (let i = 0; i < 7; i++) {
        mon1 = i == 0 ? parseInt(mon1) - 6 : parseInt(mon1) + 1;
        if (parseInt(mon1) <= 0) {
          year1 = parseInt(year1) - 1;
          mon1 = parseInt(mon1) + 12;
        } else if (parseInt(mon1) > 12) {
          year1 = parseInt(year1) + 1;
          mon1 = parseInt(mon1) - 12;
        }
        if (parseInt(mon1) < 10) {
          mon1 = '0' + mon1;
        }
        arry[i] = {
          name: year1 + '年' + mon1 + '月',
          value: mon1 + '月',
        };
      }
      //获取后6个月的数组
      for (let i = 0; i < 6; i++) {
        mon2 = parseInt(mon2) + 1;
        if (parseInt(mon2) > 12) {
          year2 = parseInt(year2) + 1;
          mon2 = parseInt(mon2) - 12;
        }
        if (parseInt(mon2) < 10) {
          mon2 = '0' + mon2;
        }
        list[i] = {
          name: year2 + '年' + mon2 + '月',
          value: mon2 + '月',
        };
      }
      this.month = arry.concat(list);
    },

    dateFormat(fmt, date) {
      let ret;
      const opt = {
        'Y+': date.getFullYear().toString(), // 年
        'm+': (date.getMonth() + 1).toString(), // 月
        'd+': date.getDate().toString(), // 日
        'H+': date.getHours().toString(), // 时
        'M+': date.getMinutes().toString(), // 分
        'S+': date.getSeconds().toString(), // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
          );
        }
      }
      return fmt;
    },
    enterequAdministration() {
      this.$router.push('/equAdministration');
    },
    enterRepair() {
      this.$router.push('/repairMge');
    },
    enterPatrol() {
      this.$router.push('/patrolRecordList');
    },
    enterMaintenance() {
      this.$router.push('/maintenanceMge');
    },
  },
};
</script>
<style lang="scss">
@import './css/common.scss';
.fivePropertyServe {
  background-color: #fff;
  p {
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    /*禁止换行显示*/
    white-space: nowrap;
  }
  .colorChange {
    color: #1890ff;
    cursor: pointer;
  }
  .colorChange:hover {
    color: red;
  }
  .danger-icon {
    margin-left: 6px;
    display: inline-block;
    width: 20px;
    cursor: pointer;
    img {
      width: 100%;
    }
  }
  .manager-danger-dialog {
    .el-dialog__header {
      border: none;
      padding: 14px 20px;
      .el-dialog__title {
        font-weight: 600;
      }
      .el-dialog__headerbtn {
        top: 14px;
      }
    }
    .el-dialog__body {
      padding: 20px 15px 30px 15px;
      .danger-info {
        color: #333333;
        font-size: 16px;
        margin-left: 40px;
        line-height: 38px;
        .item-info {
          padding-left: 40px;
        }
      }
    }
  }
  .font {
    font-size: 15px;
    //font-weight: 500;
  }
  .fontw600 {
    font-weight: 600;
  }
  .font16 {
    font-size: 16px;
  }
  .fontNum {
    font-size: 15px;
    font-weight: 600;
  }
  .font1 {
    font-size: 14px;
    font-weight: 600;
    font-family: unset;
  }
  .fontRed {
    color: red;
    font-size: 15px;
    font-weight: 600;
  }
  .fontYell {
    color: #ff9933;
  }
  .index-header {
    .more {
      color: #797979;
    }
  }
  .safeProduction-main {
    height: 295px;
    background-color: #fff;
    display: flex;
    flex-direction: row;
    /* justify-content:space-around; */
    overflow: hidden;
    .remindBorder {
      display: flex;
      width: 25px;
      background: red;
      height: 25px;
      border-radius: 10%;
      border-style: solid;
      border-width: 0;
      color: #333333;
    }
    .flexColumn {
      display: flex;
      flex-direction: column;
    }
    .flexRow {
      display: flex;
      flex-direction: row;
    }
    .marTop15 {
      margin-top: 27px;
    }
    .marTop5 {
      margin-top: 10px;
    }
    .marTop35 {
      margin-top: 35px;
    }
    .marTopleft {
      margin-top: 20px;
    }
    .left {
      align-self: center;
      display: flex;
      //flex: 1;
      min-width: 230px;
      max-width: 300px;
      flex-direction: column;
      padding-left: 20px;
      padding-right: 10px;
    }
    .right {
      display: flex;
      flex: 1;
      flex-direction: column;
      align-self: center;
      padding-left: 5px;
      // margin-left: 75px;
    }
  }
}
</style>
